// extracted by mini-css-extract-plugin
module.exports = {"title":"_5454e3c","dot":"_ce81310"};